export default __webpack_public_path__ + "159c48e92c716367807a8b2b9b611cca.png";